import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './plugins/vuetify'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './errorsLog'
import gtm from './plugins/gtm'
import AppErrorStatus from '@/components/AppErrorStatus.vue'
import LoadingStatus from '@/components/LoadingStatus'
if (process.env.NODE_ENV === 'development') {
  require('./registerLocalServiceWorker')
} else {
  require('./registerServiceWorker')
}

require('vuetify/src/stylus/app.styl')

Vue.config.productionTip = false

Vue.use(gtm)

Vue.component('app-error-status', AppErrorStatus)
Vue.component('loading-status', LoadingStatus)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
